export default {
    methods: {
        /**
         * 指定されたグループユーザーデータに、指定された権限が全て設定されているか否かを返す(※未使用)
         * @param {*} groupUserData 
         * @param {*} authorities 
         */
        mi_chackHasAuthority: function (groupUserData, authorities) {
            for(var i=0; i<authorities.length; i++) {
                if (groupUserData.authorities.find((v)=>v == authorities[i]) == null) {
                    return false
                }
            }
            return true
        },
        /**
         * 指定された場所のグループユーザー権限に、指定された権限が全て設定されているか否かを返す
         * @param {*}} place 
         * @param {*} authorities 
         */
        mi_checkGroupUserAuthority: function (place, authorities) {
            // console.log("GroupUserAuthorityChecker", "mi_checkGroupUserAuthority", place, authorities)
            for(var i=0; i<authorities.length; i++) {
                if (place.groupUserAuthorities.find((v)=>v == authorities[i]) == null) {
                    return false
                }
            }
            return true
        }
    }
}
